/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FindAllStateTowns200Response,
  FindAllStates200Response,
} from '../models/index';
import {
    FindAllStateTowns200ResponseFromJSON,
    FindAllStateTowns200ResponseToJSON,
    FindAllStates200ResponseFromJSON,
    FindAllStates200ResponseToJSON,
} from '../models/index';

export interface FindAllStateTownsRequest {
    stateId: string;
    ids?: string;
    search?: string;
    limit?: number;
    page?: number;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Get towns by state ID
     */
    async findAllStateTownsRaw(requestParameters: FindAllStateTownsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllStateTowns200Response>> {
        if (requestParameters.stateId === null || requestParameters.stateId === undefined) {
            throw new runtime.RequiredError('stateId','Required parameter requestParameters.stateId was null or undefined when calling findAllStateTowns.');
        }

        const queryParameters: any = {};

        if (requestParameters.ids !== undefined) {
            queryParameters['ids'] = requestParameters.ids;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/states/{state_id}/towns`.replace(`{${"state_id"}}`, encodeURIComponent(String(requestParameters.stateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllStateTowns200ResponseFromJSON(jsonValue));
    }

    /**
     * Get towns by state ID
     */
    async findAllStateTowns(requestParameters: FindAllStateTownsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllStateTowns200Response> {
        const response = await this.findAllStateTownsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get US states
     */
    async findAllStatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllStates200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/states`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllStates200ResponseFromJSON(jsonValue));
    }

    /**
     * Get US states
     */
    async findAllStates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllStates200Response> {
        const response = await this.findAllStatesRaw(initOverrides);
        return await response.value();
    }

}
